import { DISCOUNT_RULES, TDiscountPage } from '../constants/discountRules'

const isValidPercentage = (value: number) =>
	Number.isFinite(value) && value >= 0 && value < 100

export const resolveDiscountPercentage = (
	metadataPercentage: number | string | undefined,
	period: string | undefined,
	page?: TDiscountPage,
): number => {
	if (metadataPercentage !== undefined && metadataPercentage !== '') {
		const fromMetadata = Number(metadataPercentage)
		if (isValidPercentage(fromMetadata)) return fromMetadata
	}

	const periodRules = DISCOUNT_RULES.filter((rule) => rule.period === period)
	const rule =
		(page && periodRules.find((periodRule) => periodRule.page === page)) ||
		periodRules.find((periodRule) => !periodRule.page)

	return rule?.percentage ?? 0
}

export const getCompareAtPrice = (
	shownPrice: number,
	discountPercentage: number,
): number => {
	if (shownPrice <= 0 || discountPercentage <= 0) return 0

	const fullPrice = shownPrice / (1 - discountPercentage / 100)

	return Number.isInteger(shownPrice)
		? Math.round(fullPrice)
		: Math.round(fullPrice * 100) / 100
}
